import script from "./sport-live-tv-page.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-page.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-page.vue?vue&type=style&index=0&id=e31498ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31498ea"]])

export default __exports__